import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedService } from './shared.service';
import { MasterService } from './master.service';
import { UserService } from './user.service';
import { CookieService } from 'ngx-cookie-service';
import { TransactionService } from './transaction.service';
import { OpsService } from './ops.service';




@NgModule({
  imports: [
    CommonModule
  ],
  providers:[
      CookieService,
      SharedService,
      MasterService,
      UserService,
      TransactionService,
      OpsService
  ]
})
export class ServiceModule { 
    static forRoot(): ModuleWithProviders<ServiceModule> {
        return {
            ngModule: ServiceModule,
            providers:[
                CookieService,
                SharedService,
                MasterService,
                UserService,
                TransactionService,
                OpsService
            ]

        }
    }

}
